import { render, staticRenderFns } from "./NovaAtividadeModal.vue?vue&type=template&id=79ed7969"
import script from "./NovaAtividadeModal.vue?vue&type=script&lang=js"
export * from "./NovaAtividadeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports